import React, { Component } from 'react';
import { fetchUserMaps, getUserMapXML } from '../../../../../../Utils/VisorsUtils';
import { Oval } from 'react-loader-spinner';
import { getTranslatedKey } from '../../../../../../Utils/TranslateUtils';
import { DeleteSearchIcon, DeleteSearchIconButton, GraySearchButton } from '../../../../../../Catalog/CatalogElements';
import { FaSearch } from 'react-icons/fa';
import { crearMapConfig, downloadMap, removeMap } from '../../../../CompartirUtils';
import { LoadWrapper, MapFilter, MapWrapper, OvalContainer, Text } from '../DownloadLoadElement';
import { ButtonStyle, DeleteSVG, InputWrapper, NameInput, SectionSeparator, TitleStyle } from '../LocalMaps/LocalMapsElement';
import { MapItem } from './MapItem';
import { CardEditButtonWrapper } from '../../../../../../InformacioDePunt/InformacioPuntCardElement';
import { toast } from 'react-toastify';

export default class UserMaps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      // fileName: this.props.mapName || this.createName(),
      fileName: '',
      filterUserText: '',
      userMaps: [],
      userFilterMaps: []
    };
  }

  componentDidMount = async () => {
    await this.fetchMaps();
  };

  fetchMaps = async () => {
    this.setState({ loading: true });
    let userMaps = await fetchUserMaps();

    userMaps = userMaps.filter((map) => map.nom);
    userMaps.sort((a, b) => {
      return a.nom.toUpperCase() < b.nom.toUpperCase() ? -1 : 1;
    });

    this.setState({ userMaps: userMaps, loading: false });
  };

  componentWillUnmount = () => {
    this.setState({ userMaps: undefined });
  };

  loadMap = async (id) => {
    const xml = await getUserMapXML(id);
    await this.props.loadMap(xml);
  };

  filterResults = (text) => {
    const filteredResults = this.state.userMaps.filter((word) => word.nom.toUpperCase().includes(text.toUpperCase()));
    this.setState({ userFilterMaps: filteredResults, filterUserText: text });
  };

  onDeleteSearchBtnClick = () => {
    this.setState({ filterText: '', filterUserText: '' });
    this.filterResults('');
  };

  deleteInput = () => {
    this.setState({ fileName: '' });
  };

  deleteUserMap = (id) => {
    this.props.toggleAlert(false);
    removeMap(id, true).then(() => {
      this.fetchMaps();
    });
  };

  handleInputChange = (e) => {
    this.setState({ fileName: e.target.value });
  };

  onDeleteClick = (id) => {
    const mapName = this.state.userMaps.find((map) => map.map_id === id).nom;
    const Component = () => (
      <>
        <Text>{getTranslatedKey('deleteMap') + mapName}</Text>
        <CardEditButtonWrapper>
          <ButtonStyle onClick={() => this.props.toggleAlert(false)}>{getTranslatedKey('cancel')}</ButtonStyle>
          <ButtonStyle eliminar onClick={() => this.deleteUserMap(id)}>
            {getTranslatedKey('delete')}
          </ButtonStyle>
        </CardEditButtonWrapper>
      </>
    );
    this.props.toggleAlert(true, <Component />, 'Atenció', true, false, true);
  };
  onSaveClick = (text) => {
    if (text || this.state.fileName !== '') {
      const mapName = text || this.state.fileName.trim();
      let modalText = getTranslatedKey('replaceMap1') + mapName + getTranslatedKey('replaceMap2');

      if (text) {
        modalText = getTranslatedKey('replaceFast1') + mapName + getTranslatedKey('replaceFast2');
      }
      if (this.state.userMaps.findIndex((map) => map.nom === mapName) !== -1) {
        const Component = () => (
          <>
            <Text>{modalText}</Text>
            <CardEditButtonWrapper>
              <ButtonStyle onClick={() => this.props.toggleAlert(false)}>{getTranslatedKey('cancel')}</ButtonStyle>
              <ButtonStyle onClick={() => this.saveMapToDB(text)}>{getTranslatedKey('replaceAccept')}</ButtonStyle>
            </CardEditButtonWrapper>
          </>
        );
        this.props.toggleAlert(true, <Component />, getTranslatedKey('replaceTitle'), true, false, true);
      } else {
        this.saveMapToDB(text);
      }
    } else {
      toast.error(getTranslatedKey('errorNoName'));
    }
  };

  saveMapToDB = (text) => {
    const mapName = text || this.state.fileName.trim();
    let conf = crearMapConfig(
      this.props.map,
      this.props.arrayLayers,
      this.props.fonsActiu,
      this.props.transparenciaFons,
      mapName,
      this.props.vectorTilesSource,
      this.props.favList
    );
    downloadMap(conf).then(() => {
      this.props.toggleAlert(false);
      this.fetchMaps();
    });
  };
  render() {
    if (this.state.loading) {
      return (
        <OvalContainer>
          <Oval
            height={window.innerHeight > 400 ? 80 : 40}
            width={window.innerHeight > 400 ? 80 : 40}
            color="#febf00"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#ccc"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </OvalContainer>
      );
    } else {
      return (
        <LoadWrapper>
          <>
            <>
              <TitleStyle>{getTranslatedKey('userMapsTitle')}</TitleStyle>
              <div style={{ display: 'flex', height: '28px', marginTop: '15px' }}>
                <GraySearchButton title={getTranslatedKey('cerca')}>
                  <FaSearch
                    style={{
                      verticalAlign: 'middle',
                      transform: 'translate(0px, -2px)'
                    }}
                  />
                </GraySearchButton>
                <MapFilter
                  value={this.state.filterText}
                  placeholder={getTranslatedKey('filterMaps')}
                  onChange={(e) => this.filterResults(e.target.value)}
                />
                <DeleteSearchIconButton title={getTranslatedKey('esborra')} onClick={() => this.onDeleteSearchBtnClick()}>
                  <DeleteSearchIcon text={this.state.filterText} alt={getTranslatedKey('altDeleteIcon')} title={getTranslatedKey('esborrarCerca')}>
                    <path
                      xmlns="http://www.w3.org/2000/svg"
                      d="M19,15.59L17.59,17L14,13.41L10.41,17L9,15.59L12.59,12L9,8.41L10.41,7L14,10.59L17.59,7L19,8.41L15.41,12L19,15.59M22,3A2,2 0 0,1 24,5V19A2,2 0 0,1 22,21H7C6.31,21 5.77,20.64 5.41,20.11L0,12L5.41,3.88C5.77,3.35 6.31,3 7,3H22M22,5H7L2.28,12L7,19H22V5Z"
                    />
                  </DeleteSearchIcon>
                </DeleteSearchIconButton>
              </div>
              <MapWrapper>
                {this.state.userFilterMaps.length === 0 && this.state.filterUserText === '' ? (
                  this.state.userMaps.map((map) => {
                    return (
                      <MapItem
                        map={map}
                        onHover={() => this.setState({ mapHovered: map.map_id })}
                        onLeave={() => this.setState({ mapHovered: false })}
                        hovered={this.state.mapHovered === map.map_id}
                        onClick={() => this.loadMap(map.map_id)}
                        deleteUserMap={() => this.onDeleteClick(map.map_id)}
                        overWriteMap={() => this.onSaveClick(map.nom)}
                        isUserMap={true}
                      />
                    );
                  })
                ) : this.state.userFilterMaps.length > 0 ? (
                  this.state.userFilterMaps.map((map) => (
                    <MapItem
                      map={map}
                      onHover={() => this.setState({ mapHovered: map.map_id })}
                      onLeave={() => this.setState({ mapHovered: false })}
                      hovered={this.state.mapHovered === map.map_id}
                      onClick={() => this.loadMap(map.map_id)}
                      deleteUserMap={() => this.onDeleteClick(map.map_id)}
                      overWriteMap={() => this.onSaveClick(map.nom)}
                      isUserMap={true}
                    />
                  ))
                ) : (
                  <Text>{getTranslatedKey('noResultsMap')}</Text>
                )}
              </MapWrapper>
            </>
            <SectionSeparator />
            <>
              <TitleStyle>{getTranslatedKey('saveCat')}</TitleStyle>
              <InputWrapper>
                <NameInput onChange={(e) => this.handleInputChange(e)} placeholder={getTranslatedKey('fileNamePH')} value={this.state.fileName} />
                {this.state.fileName !== '' && (
                  <DeleteSVG onClick={() => this.deleteInput()}>
                    <svg
                      alt={getTranslatedKey('esborrarCercaBtn')}
                      title={getTranslatedKey('esborrarCerca')}
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      viewBox="0 0 24 24"
                      width="22"
                      fill="white"
                      height="22"
                      class="sc-kDvujY bwDwBu">
                      <path
                        xmlns="http://www.w3.org/2000/svg"
                        d="M19,15.59L17.59,17L14,13.41L10.41,17L9,15.59L12.59,12L9,8.41L10.41,7L14,10.59L17.59,7L19,8.41L15.41,12L19,15.59M22,3A2,2 0 0,1 24,5V19A2,2 0 0,1 22,21H7C6.31,21 5.77,20.64 5.41,20.11L0,12L5.41,3.88C5.77,3.35 6.31,3 7,3H22M22,5H7L2.28,12L7,19H22V5Z"></path>
                    </svg>
                  </DeleteSVG>
                )}
              </InputWrapper>
              <ButtonStyle onClick={() => this.onSaveClick()}>{getTranslatedKey('desa')} </ButtonStyle>
            </>
          </>
        </LoadWrapper>
      );
    }
  }
}
